import { Directive, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

@Directive({
	selector: '[localizedRouterLink]',
	standalone: true
})
export class LanguageRouterLinkDirective {
	@Input('localizedRouterLink') commands: any | any[] = [];
	@Input() queryParams?: { [k: string]: any }; // Add queryParams input
	@Input() fragment?: string; // Add fragment input
	@Input() target?: string;


	constructor(private translocoService: TranslocoService, private router: Router) { }

	@HostListener('click')
	onClick() {
		// Get the current language from the service
		const currentLang = this.translocoService.getActiveLang();

		let commandsWithLang: any[] = [];
		let commandsArray: string[] = [];

		// if (typeof this.commands === 'string') {
		// 	// Split the string by '/' and remove empty parts to avoid extra slashes
		// 	const sanitizedCommands = this.commands.split('/').filter(part => part !== '');
		// 	commandsWithLang = [`/${currentLang}`, ...sanitizedCommands];
		// } else if (Array.isArray(this.commands)) {
		// 	commandsWithLang = [`/${currentLang}`, ...this.commands];
		// 	console.log(commandsWithLang)
		// }

		if (typeof this.commands === 'string') {
			// Split the string by '/' and filter out empty parts
			commandsArray = this.commands.split('/').filter(part => part !== '');
		} else if (Array.isArray(this.commands)) {
			// Flatten the array, join it, split by '/' and filter out empty parts
			commandsArray = this.commands
				.flat()
				.join('/')
				.split('/')
				.filter(part => part !== '');
		}

		// Prepend the language to the commands array
		commandsWithLang = [`/${currentLang}`, ...commandsArray];
		// Navigate using the updated commands
		if (this.target === '_blank'){
			const urlTree = this.router.createUrlTree(commandsWithLang, {
				queryParams: { ...this.queryParams },
				fragment: this.fragment
			});
			const url = this.router.serializeUrl(urlTree);
			window.open(url, '_blank');
		}
		else {
			this.router.navigate(commandsWithLang, {
				queryParams: { ...this.queryParams },
				fragment: this.fragment
			});
		}
	}
}